module.exports = __webpack_public_path__ + "static/media/google.20e7d395.svg";